module.exports = __webpack_public_path__ + "static/bg-real-estate-eb20ab193c04006fe71fd5a6075b24fc.jpg";